
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 11.9944C17 10.0278 15.8667 8.33888 14.2222 7.51666V9.97222L16.9444 12.6944C16.9778 12.4722 17 12.2389 17 11.9944ZM19.7778 11.9944C19.7778 13.0389 19.5556 14.0167 19.1778 14.9278L20.8556 16.6055C21.5889 15.2278 22 13.6611 22 11.9944C22 7.73888 19.3333 4.09444 15.5778 2.6611C14.9222 2.41666 14.2222 2.91666 14.2222 3.61666V3.82777C14.2222 4.24999 14.5 4.61666 14.9 4.77222C17.7556 5.91666 19.7778 8.71666 19.7778 11.9944ZM2.71111 2.69444C2.32222 3.08333 2.32222 3.71666 2.71111 4.10555L7.26667 8.6611H3.11111C2.5 8.6611 2 9.1611 2 9.77222V14.2167C2 14.8278 2.5 15.3278 3.11111 15.3278H6.44444L11.0556 19.9389C11.4 20.2833 12 20.0389 12 19.55V13.4167L16.7222 18.1389C16.1667 18.5722 15.5556 18.9389 14.8889 19.2167C14.5 19.3833 14.2222 19.7389 14.2222 20.1611V20.3833C14.2222 21.0833 14.9222 21.5833 15.5667 21.3389C16.5778 20.95 17.5 20.4056 18.3222 19.7389L19.8889 21.3055C20.2778 21.6944 20.9111 21.6944 21.3 21.3055C21.6889 20.9167 21.6889 20.2833 21.3 19.8944L4.11111 2.69444C3.72222 2.30555 3.08889 2.30555 2.7 2.69444H2.71111ZM11.0556 4.04999L9.67778 5.42777L12 7.74999V4.44999C12 3.94999 11.4 3.70555 11.0556 4.0611V4.04999Z","fill":"#16171F"}})])
          )
        }
      }
    